import eventLogs from './eventLogs';
import permissions from './permissions';
import statisticsPortal from './statisticsPortal';
import statisticsPublic from './statisticsPublic';
import users from './users';

export default {
  statisticsPublic,
  statisticsPortal,
  eventLogs,
  permissions,
  users,
};
